import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import shortid from "shortid";
import useConstants from "@hooks/useConstants";

const ProJobTypes = () => {
	const classes = useStyles("Pro");

	const { jobTypesH2, jobTypes } = useConstants("ProJobTypes");

	return (
		<React.Fragment>
			{jobTypes.length > 0 && (
				<Box
					component="section"
					className={classes.hiwWrapper}
					display={"flex"}
					alignItems={"center"}
					justifyContent={"center"}
					bgcolor="grey.50"
				>
					<Container maxWidth={false} className={classes.proContainer}>
						<h2 className={classes.joinH2}>{jobTypesH2}</h2>

						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Paper variant="outlined">
									<Grid container spacing={1} style={{ padding: 10 }}>
										{jobTypes.map((type) => (
											<Grid key={shortid.generate()} item xs={12} sm={6} md={4}>
												<Button key={shortid.generate()} href={type.link}>
													{type.title}
												</Button>
											</Grid>
										))}
									</Grid>
								</Paper>
							</Grid>
						</Grid>
					</Container>
				</Box>
			)}
		</React.Fragment>
	);
};

export default ProJobTypes;
